/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useMemo } from 'react';
import { useLabels } from '@/hooks/useLabels';
import { Rating } from './Rating';

type Props = {
  handleFilter: (value: number) => void;
  selectedRatings?: number[];
};

const labelMap = {
  star: 'label_reviews_star',
  stars: 'label_reviews_stars',
};

const stars = new Array(5).fill(null);

export const RatingFilter = ({ handleFilter, selectedRatings }: Props) => {
  const isSelected = useMemo(() => {
    return (rating: number) => selectedRatings?.includes(rating) ?? false;
  }, [selectedRatings]);

  const labels = useLabels(labelMap);

  const items = useMemo(
    () =>
      stars.map((_, i) => {
        const star = 5 - i;
        return {
          label: `${star} ${star === 1 ? labels.star : labels.stars}`,
          value: star,
        };
      }),
    [labels],
  );

  return (
    <div data-testid="rating-filter">
      <ul>
        {items.map((item, index) => {
          return (
            <Rating
              index={index}
              key={`${item.value}`}
              checked={isSelected(item.value)}
              handleFilter={handleFilter}
              label={item.label}
              value={item.value}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default RatingFilter;
